import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from '@/pages/App.tsx'
import "@/index.css"

const rootEl = document.getElementById('root')
if(!rootEl) throw new Error("failed bootstrap app");

const root = createRoot(rootEl)

root.render(
  <StrictMode>
    <App />
  </StrictMode>
)
